// extracted by mini-css-extract-plugin
module.exports = {"buttons":"ConfirmModal_buttons__19woP","alertIcon":"ConfirmModal_alertIcon__3f9jh"};